// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"CloseButton_closeButton__A6LdK"};